<template>
  <fullscreen
    v-model="fullscreen"
    :teleport="teleport"
    :page-only="pageOnly"
    style="z-index: 10"
  >
    <div
      class="fullscreen-wrapper"
      :class="fullscreen ? 'fullscreen-wrapper-full' : ''"
    >
      <v-container
        fluid
        style="border: 1px solid black; background-color: white"
        :class="fullscreen ? 'container-full' : ''"
      >
        <v-row>
          <v-col cols="10">
            <QscSelect
              type="single"
              :options="options1"
              :selected.sync="value1"
              :shouldSelectObject="false"
              propertyForValue="name"
              class="qsc-select-container"
              :search="true"
            />
          </v-col>
         
          <v-col align="end" cols="2">
            <v-btn
              small
              fab
              dark
              style="margin-right: 6px"
              @click="toggleExpand"
            >
              <v-icon>{{
                fullscreen ? "mdi-window-minimize" : "mdi-arrow-expand-all"
              }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
                <v-row no-gutters>
          <v-col sm="6" md="2">
            <v-card max-width="344">


              <v-card-subtitle>
                Selected Node:
              </v-card-subtitle>
              <v-card-text>
                <ul>
                  <li>
                    <strong>Name:</strong> {{selectedNode ? selectedNode.name : ''}}
                  </li>
                  <li>
                    <strong>Group:</strong> {{selectedNode ? selectedNode.group : ''}}
                  </li>
                </ul>
              </v-card-text>

            </v-card>
          </v-col>
          <v-col sm="6" md="10">
            <div style="text-align:center;">
              <svg
                id="viz"
                class="container-border"
                :width="screenWidth"
                :height="screenHeight"
              ></svg>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container>
      <v-row class="justify-end">
            <v-spacer></v-spacer>
                <v-btn v-if="status"
                  @click="reload"
                  >
                  Cancel
                </v-btn>
                <v-btn v-if="status"
                  @click="update"
                  color="success"
                  class="ml-2">
                  Save
                </v-btn>
          </v-row>
          <qsc-data-table
            :columns="columns"
            :childs-columns="childs_columns"
            :rows="qscdata"
            :edit-button="true"
            :draggable-button="false"
            :create-button="true"
            :delete-button="true"
            v-on:emitChangeValue="handleEmitChangeValue($event)"
        />
    </v-container>
  </fullscreen>
</template>

<script>
import * as d3 from "d3";
import { QscSelect } from "@quasiris/qsc-data-inputs";
import { component } from "vue-fullscreen";
export default {
  name: "ExplainGraph",
  components: { QscSelect, fullscreen: component },
  props: {
    sourceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      status: false,
      fullscreen: false,
      teleport: false,
      pageOnly: true,
      screenWidth: 800,
      screenHeight: 600,
      reactiveSourceData: {},
      reArrangedSourceData:{},
      value1: "",
      options1: [],
      selectedNode: {},
      selected_target_node: null,
      selected_link : null,
      new_line: null,
      circlesg: null,
      linesg: null,
      should_drag : false,
      drawing_line : false,
      columns: [
        {
          name: 'name',
          label: 'Name',
          inputType: 'input',
          class: '',
          defaultValue: '',
          placeholder: 'Name'
        },
        {
          name: 'group',
          label: 'Group',
          inputType: 'input-number',
          class: '',
          defaultValue: 0,
        },
      ],
      childs_columns: [
        {
          name: 'name',
         label: 'Name',
          inputType: 'qsc-select',
          qscSelect: {
            options: [],
            shouldSelectObject: false,
            type: "single",
            propertyForValue: "name"
          },
          class: '',
          defaultValue: '',
          style: 'min-width: 300px !important'
        },
        {
          name: 'value',
          label: 'Value',
          inputType: 'input-number',
          class: '',
          defaultValue: 0,
        },
      ],
      qscdata: [],
      updatedRows: [],
    };
  },
  created(){
    this.reactiveSourceData = {...this.sourceData };
    this.reArrangedSourceData = {...this.sourceData};
    this.mapDataToQSCFirst();
    
  },
  methods: {
    reArrangeNodes(node){
      this.reArrangedSourceData = {}
      const newNodes = this.reactiveSourceData.nodes.filter(n => n.name !== node.name);
      newNodes.unshift(node)
      this.reArrangedSourceData = {nodes: newNodes, links: this.reactiveSourceData.links};
      this.mapDataToQSCAfter()
    },
    handleEmitChangeValue(value) {
      this.status = !value.saveStatus;
      this.updatedRows = value.rows;
    },
    reload(){
      // this.initializeGraph();
      this.mapDataToQSCAfter();
      this.status=false;
    },
    update(){
      this.reactiveSourceData = {nodes:[], links:[]};
      this.reactiveSourceData.nodes = this.updatedRows.map(node => {
        let n ={}
        if(node.node) {
          n = node.node;
          n.name= node.name;
          n.group= node.group;
        } else {
          n={name: node.name, group: parseInt(node.group, 10), childs:[]}
    }
    return n;
    })
      this.updatedRows.forEach(node => { 
        node.childs.forEach(link => {
          if(link.link){
          if(this.reactiveSourceData.nodes.find( node => node.name === link.link.source.name) && 
          this.reactiveSourceData.nodes.find( node => node.name === link.link.target.name)){
            const targetNode = this.reactiveSourceData.nodes.find( node => node.name === link.name)
            this.reactiveSourceData.links.push(link.link ? {...link.link, target:targetNode, value:parseInt(link.value, 10)} : {source:node.name, target:link.name, value:parseInt(link.value, 10)})
          }
          }
          else{
            this.reactiveSourceData.links.push({source:node.name, target:link.name, value:parseInt(link.value, 10)})
          }
          
          })
      })
      this.reArrangedSourceData = {nodes: this.reactiveSourceData.nodes, links: this.reactiveSourceData.links}
      this.initializeGraph();
      this.mapDataToQSCAfter();
      this.status=false;
    },
    mapDataToQSCFirst(){
      this.qscdata = [];
      this.getIDsandGroupsFromFile();

      this.childs_columns[0].qscSelect.options = this.reactiveSourceData.nodes.map(node => {return {name: node.name}});
      this.qscdata = this.reactiveSourceData.nodes.map(node => {return {name: node.name, group: node.group, childs:[], node}});
        
      
    this.reactiveSourceData.links.forEach(link => {
      const source = this.qscdata.find(o => o.name === link.source.name);
      const target = this.qscdata.find(o => o.name === link.target.name);
      if(source !== undefined && target !== undefined){
        source.childs.push({name: target.name, value: link.value, link})
      }
    })
    },
    mapDataToQSCAfter(){
      this.qscdata = [];
      this.getIDsandGroupsFromFile();
      this.childs_columns[0].qscSelect.options = this.reArrangedSourceData.nodes.map(node => {return {name: node.name}});
      this.qscdata = this.reArrangedSourceData.nodes.map(node => {return {name: node.name, group: node.group, childs:[], node}});
      this.reactiveSourceData.links.forEach(link => {
      const source = this.qscdata.find(o => o.name === link.source.name);
      const target = this.qscdata.find(o => o.name === link.target.name);
      if(source !== undefined && target !== undefined){
        source.childs.push({name: target.name, value: link.value, link})
      }
    })
    },
    getIDsandGroupsFromFile() {
      const groups = [];
      this.options1 = [];
      this.reactiveSourceData.nodes.forEach((node) => {
        if (!groups.includes(node.group)) groups.push(node.group);
        this.options1.push({
          name: node.name,
          group: node.group,
        });
      });
    },
    toggleExpand() {
      if (!this.fullscreen) {
        this.screenWidth = screen.width;
        this.screenHeight = screen.height;
      } else {
        this.screenWidth = 800;
        this.screenHeight = 600;
      }
      this.fullscreen = !this.fullscreen;
      if (this.fullscreen) {
        let elHtml = document.getElementsByTagName("html")[0];
        elHtml.style.overflowY = "hidden";
      } else {
        let elHtml = document.getElementsByTagName("html")[0];
        elHtml.style.overflowY = null;
      }
    },
    displayBySearch() {
      const vueInstance = this;
      const nodes = d3.select("g.nodes").selectAll("circle");
      const links = d3.selectAll("g.link")
      const labels = d3.select("g.labelNodes").selectAll("text");
      this.selectedNode = this.reactiveSourceData.nodes.find(
        (node) => node.name === this.value1
      );
      let adjlist = [];
      this.reactiveSourceData.links.forEach(function(d) {
        adjlist[d.source.index + "-" + d.target.index] = true;
        adjlist[d.target.index + "-" + d.source.index] = true;
      });
      function neigh(a, b) {
        return a === b || adjlist[a + "-" + b];
      }
      nodes
        .style("stroke", function(o) {
          return vueInstance.value1
            ? vueInstance.value1 === o.name
              ? "yellow"
              : "none"
            : "none";
        })
        .style("stroke-width", function(o) {
          return vueInstance.value1
            ? vueInstance.value1 === o.name
              ? 4
              : 0.1
            : 0.1;
        })
        .style("opacity", function(o) {

          return vueInstance.value1
          ? vueInstance.value1 === o.name
            ? 1
            : neigh(vueInstance.selectedNode.index, o.index)
              ? 1
              : 0.1
            : 1;
        });
      links.style("opacity", function(o) {
        return vueInstance.value1
          ? vueInstance.value1 === o.source.name ||
            vueInstance.value1 === o.target.name
            ? 1
            : o.source.index === vueInstance.selectedNode.index ||
              o.target.index === vueInstance.selectedNode.index
            ? 1
            : 0.1
          : 1;
      });
      labels.attr("display", function(o) {
        return vueInstance.value1
          ? vueInstance.value1 === o.node.name
            ? "block"
            : neigh(vueInstance.selectedNode.index, o.node.index)
            ? "block"
            : "none"
          : "block";
      });
    },
    rightClick(event) {
      event.preventDefault();
      this.value1 = event.target.__data__.name;
      event.stopPropagation();
      this.reArrangeNodes(event.target.__data__);
    },
    initializeGraph() {
      this.getIDsandGroupsFromFile();

      d3.select("#viz")
        .select("g")
        .remove();
      let color = d3.scaleOrdinal(d3.schemeCategory10);

      let graph = this.reactiveSourceData;
      let label = {
        nodes: [],
        links: [],
      };
      graph.nodes.forEach(function(d, i) {
        label.nodes.push({ node: d });
        label.nodes.push({ node: d });
        label.links.push({
          source: i * 2,
          target: i * 2 + 1,
        });
      });

      let labelLayout = d3
        .forceSimulation(label.nodes)
        .force("charge", d3.forceManyBody().strength(-50))
        .force(
          "link",
          d3
            .forceLink(label.links)
            .distance(0)
            .strength(2)
        );

      d3.forceSimulation(graph.nodes)
        .force("charge", d3.forceManyBody().strength(-3000))
        .force(
          "center",
          d3.forceCenter(this.screenWidth / 2, this.screenHeight / 2)
        )
        .force("x", d3.forceX(this.screenWidth / 2).strength(1))
        .force("y", d3.forceY(this.screenHeight / 2).strength(1))
        .force(
          "link",
          d3
            .forceLink(graph.links)
            .id(function(d) {
              return d.name;
            })
            .distance(50)
            .strength(1)
        )
        .on("tick", ticked)
        

      let svg = d3
        .select("#viz")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", "0 0 " + this.screenWidth + " " + this.screenHeight)
        .on("click", () => {
          this.value1 = "";
          this.selectedNode = {};
        });

      let container = svg.append("g");
        svg.call(
        d3
          .zoom()
          .scaleExtent([0.1, 4]) // eslint-disable-line
          .on("zoom", function(event) {
            container.attr("transform", event.transform);
          })
      );

      let link = container
        .append("g")
        .attr("class", "links")
        .selectAll("line")
        .data(graph.links)
        .enter()
        .append("g")
        .attr("class", "link")
        .append("line")
        .attr("stroke", "#aaa")
        .attr("stroke-width", "2px");

              link
        .attr("x1", function(d) {
          return d.source.x;
        })
        .attr("y1", function(d) {
          return d.source.y;
        })
        .attr("x2", function(d) {
          return d.target.x;
        })
        .attr("y2", function(d) {
          return d.target.y;
        });

      let linkText = svg
        .selectAll(".link")
        .append("text")
        .attr("class", "link-label")
        .attr("font-family", "Arial, Helvetica, sans-serif")
        .attr("fill", "Black")
        .style("font", "normal 12px Arial")
        .attr("dy", ".35em")
        .attr("text-anchor", "middle")
        .text(function(d) {
          return d.value;
        });

      linkText
        .attr("x", function(d) {
          return (d.source.x + d.target.x) / 2;
        })
        .attr("y", function(d) {
          return (d.source.y + d.target.y) / 2;
        });

      let node = container
        .append("g")
        .attr("class", "nodes")
        .selectAll("g")
        .data(graph.nodes)
        .enter()
        .append("circle")
        .attr("r", 8)
        .attr("cursor", "pointer")
        .attr("fill", function(d) {
          return color(d.group);
        })
        .on("click", this.rightClick);

      let labelNode = container
        .append("g")
        .attr("class", "labelNodes")
        .selectAll("text")
        .data(label.nodes)
        .enter()
        .append("text")
        .text(function(d, i) {
          return i % 2 === 0 ? "" : d.node.name;
        })
        .style("fill", "#555")
        .style("font-family", "Arial")
        .style("font-size", 12)
        .style("pointer-events", "none");

      function ticked() {
        node.call(updateNode);
        link.call(updateLink);

        labelLayout.alphaTarget(0.3).restart();
        labelNode.each(function(d, i) {
          if (i % 2 === 0) {
            d.x = d.node.x;
            d.y = d.node.y;
          } else {
            let b = this.getBBox();

            let diffX = d.x - d.node.x;
            let diffY = d.y - d.node.y;

            let dist = Math.sqrt(diffX * diffX + diffY * diffY);

            let shiftX = (b.width * (diffX - dist)) / (dist * 2);
            shiftX = Math.max(-b.width, Math.min(0, shiftX));
            let shiftY = 16;
            this.setAttribute(
              "transform",
              "translate(" + shiftX + "," + shiftY + ")"
            );
          }
        });
        labelNode.call(updateNode);
        linkText
          .attr("x", function(d) {
            return d.source.x + (d.target.x - d.source.x) * 0.5;
          })
          .attr("y", function(d) {
            return d.source.y + (d.target.y - d.source.y) * 0.5;
          });
      }

      function fixna(x) {
        if (isFinite(x)) return x;
        return 0;
      }

      function updateLink(link) {
        link
          .attr("x1", function(d) {
            return fixna(d.source.x);
          })
          .attr("y1", function(d) {
            return fixna(d.source.y);
          })
          .attr("x2", function(d) {
            return fixna(d.target.x);
          })
          .attr("y2", function(d) {
            return fixna(d.target.y);
          });
      }

      function updateNode(node) {
        node.attr("transform", function(d) {
          return "translate(" + fixna(d.x) + "," + fixna(d.y) + ")";
        });
      }
    },
  },
  watch: {
    value1: {
      handler(newOptions, oldOptions) {
        if (newOptions !== oldOptions) {
          this.displayBySearch();
        }
      }
    },
    sourceData: {
      handler(newVal) {
        this.reactiveSourceData = newVal;
        this.initializeGraph();
        this.mapDataToQSCFirst();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.initializeGraph();
  },
};
</script>
<style>
.qsc-select-container ul {
  list-style: none;
}
.fullscreen-wrapper {
  width: 100%;
  background: #333;
  align-items: center;
  justify-content: center;
}
.fullscreen-wrapper-full {
  height: 100vh;
}
.container-full {
  max-width: 100% !important;
  height: 100vh !important;
}
</style>
